import { useSelector } from "react-redux";
import { useMutation } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { showMutationError } from "utils/showMutationError";

export const useJoinVideoCall = () => {
  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useMutation({
    meta: { skipGlobalError: true },
    mutationFn: async ({ appointmentId, userType = "PROVIDER" }) => {
      if (!appointmentId) {
        throw new Error("Appointment ID is required");
      }

      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/video/appointments/join-token`,
        {
          appointmentId,
          userType
        }
      );
      return response.data;
    },
    onError: (error) => showMutationError(error, "Failed to join video call. Please try again."),
  });
};